// AuthHeader is a singleton class that manages the authentication header for the application.
class AuthHeaderManager {
  private static instance: AuthHeaderManager | null = null;
  private token: string | null = null;

  private constructor() {}

  public static getInstance(): AuthHeaderManager {
    if (!AuthHeaderManager.instance) {
      AuthHeaderManager.instance = new AuthHeaderManager();
    }
    return AuthHeaderManager.instance;
  }

  public setToken(token: string): void {
    if (token.trim() === "") {
      throw new Error("Token cannot be empty");
    }

    // add Bearer prefix if it is not present
    const normalizedToken = token.startsWith("Bearer ") ? token : `Bearer ${token}`;

    this.token = normalizedToken;
  }

  // get Authorization header - return null if token is not set
  public getAuthorizationHeader(): { Authorization: string } | null {
    if (!this.token || this.token.trim().length === 0) {
      return null;
    }

    return { Authorization: this.token };
  }

  public getAuthorizationHeaderOrThrow(): AuthHeader {
    const header = this.getAuthorizationHeader();
    if (!header) {
      throw new Error("Token is not set");
    }
    return header;
  }

  public clearToken(): void {
    this.token = null;
  }
}

export type AuthHeader = { Authorization: string };
export const authHeader: {
  get: () => AuthHeader | null;
  getOrThrow: () => AuthHeader;
  set: (token: string) => void;
  clear: () => void;
} = {
  get: () => AuthHeaderManager.getInstance().getAuthorizationHeader(),
  getOrThrow: () => AuthHeaderManager.getInstance().getAuthorizationHeaderOrThrow(),
  set: (token: string) => {
    AuthHeaderManager.getInstance().setToken(token);
  },
  clear: () => {
    AuthHeaderManager.getInstance().clearToken();
  },
};
